import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BrandingCtx = createContext({ logoDataUrl: null, refresh: () => {}, setLogoDataUrl: () => {} });

/**
 * Global branding provider. Fetches the custom logo (if any) once on
 * mount and re-exposes it via context so the shared <Logo /> can render
 * the uploaded PNG instead of the default SVG word-mark. Admins can
 * push updates in-place via `setLogoDataUrl` after uploading.
 */
export function BrandingProvider({ children }) {
  const [logoDataUrl, setLogoDataUrl] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/branding");
      setLogoDataUrl(data?.logo_data_url || null);
    } catch { /* branding is best-effort — fall back to default */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <BrandingCtx.Provider value={{ logoDataUrl, refresh, setLogoDataUrl }}>
      {children}
    </BrandingCtx.Provider>
  );
}

export function useBranding() { return useContext(BrandingCtx); }
